const Dwarf = require('./Dwarf');
const Elf = require('./Elf');
const Faerie = require('./Faerie');
const Poppet = require('./Poppet');

module.exports = {
  'dwarf': Dwarf,
  'elf': Elf,
  'faerie': Faerie,
  'poppet': Poppet,
};
